// extracted by mini-css-extract-plugin
export var editor = "_1p-0";
export var flowSidebar = "_60-2";